// What the key guide says over each page: its heading, the sections of
// the page's other views, and the keys its focused controls handle.

import { dashboardOffers } from '../commands/dashboard';
import { branchOffers } from '../commands/page';
import { findFileListKeys, headerPickerKeys, jumpBarKeys, overviewKeys, stackMapKeys, stackMenuKeys, tabListKeys, timelineHandleKeys, timelineMenuKeys, timelinePointKeys } from './controls';
import { PAGES, pageSections, SCOPES } from './bindings';
import type { GuideSpec } from './router';

/** The sections of every view of a pull request, and of the comment boxes over them: what its guide lists beside the view shown. */
const PR_SECTIONS = [...new Set([...Object.keys(PAGES).filter((page) => PAGES[page].includes('pullRequest')).flatMap(pageSections), ...SCOPES.field.sections])];

/** The guide over the pull request pages. */
export const PR_GUIDE: GuideSpec = {
  heading: 'Move through the review',
  intro: 'One grammar on every view: select, then act. Keys work outside text inputs (`Esc` leaves one) and embedded pages (click outside one to come back).',
  related: PR_SECTIONS,
  controls: [timelinePointKeys, timelineHandleKeys, timelineMenuKeys, findFileListKeys, tabListKeys, stackMenuKeys, jumpBarKeys],
  // The header pickers are a compare's and a history's: a pull request's base and head are GitHub's.
  offers: (c) => !(c.kind === 'open' && (c.menu === 'base' || c.menu === 'head')),
};

/**
 * The guide over a compare's page: the pull request's grammar, less what a
 * compare has not (its other views, its stack, drafts and comments).
 */
export const COMPARE_GUIDE: GuideSpec = {
  heading: 'Move through the compare',
  intro: PR_GUIDE.intro,
  related: [...new Set([...pageSections('files'), ...SCOPES.field.sections])],
  controls: [timelinePointKeys, timelineHandleKeys, timelineMenuKeys, findFileListKeys, tabListKeys, headerPickerKeys, jumpBarKeys],
  offers: branchOffers,
};

/** The guide over a branch history's page: what a compare's lists, a history having the same two views. */
export const REF_GUIDE: GuideSpec = { ...COMPARE_GUIDE, heading: 'Move through the history' };

/** The guide over the dashboard: what it has something for, since no other view's keys work there. */
export const DASH_GUIDE: GuideSpec = {
  heading: 'Move through the dashboard',
  intro: 'Keys work outside text inputs (`Esc` leaves one). The row the keys work from is ringed while the list has the focus.',
  related: [],
  controls: [overviewKeys, stackMapKeys, jumpBarKeys],
  offers: dashboardOffers,
};
